import { ArrowRight, Play } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router";

export function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-[#f2eadf]">
      <div className="absolute -left-20 top-20 h-72 w-72 rounded-full bg-[#dfe6d5]/70 blur-3xl" />
      <div className="absolute -right-20 bottom-0 h-80 w-80 rounded-full bg-[#d9b991]/40 blur-3xl" />

      <div className="rini-container relative grid min-h-[680px] items-center gap-12 py-16 lg:grid-cols-[1.05fr_0.95fr] lg:py-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <p className="mb-5 text-sm font-semibold uppercase tracking-[0.25em] text-[#70845b]">
            Gentle care, naturally made
          </p>

          <h1 className="rini-heading text-5xl font-semibold leading-[1.05] sm:text-6xl lg:text-7xl">
            Handmade rituals for naturally beautiful skin and hair.
          </h1>

          <p className="mt-7 max-w-xl text-lg leading-8 text-[#625b54]">
            Discover thoughtfully handcrafted soaps, hair oils, lip care,
            herbal hair colours and gifting collections made with care,
            transparency and nature-inspired ingredients.
          </p>

          <div className="mt-9 flex flex-wrap gap-4">
            <Link
              to="/shop"
              className="rini-button-primary"
            >
              Shop the collection
              <ArrowRight size={18} />
            </Link>

            <Link
              to="/making-rini"
              className="rini-button-secondary"
            >
              <Play size={17} />
              See how it is made
            </Link>
          </div>

          <div className="mt-12 grid max-w-xl grid-cols-3 gap-4 border-t border-[#5e3b2c]/15 pt-7">
            <div>
              <strong className="block text-xl text-[#5e3b2c]">
                Small-batch
              </strong>
              <span className="mt-1 block text-sm text-[#746d65]">
                Carefully handcrafted
              </span>
            </div>

            <div>
              <strong className="block text-xl text-[#5e3b2c]">
                Honest
              </strong>
              <span className="mt-1 block text-sm text-[#746d65]">
                Ingredient-led care
              </span>
            </div>

            <div>
              <strong className="block text-xl text-[#5e3b2c]">
                Made with love
              </strong>
              <span className="mt-1 block text-sm text-[#746d65]">
                From RiNi to you
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="relative"
        >
          <div className="aspect-[4/5] overflow-hidden rounded-[3rem] bg-[#ded4c5] shadow-[0_30px_80px_rgba(73,50,38,0.18)]">
            <div className="flex h-full items-center justify-center p-10 text-center">
              <div>
                <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-white/75 font-serif text-3xl text-[#5e3b2c]">
                  RiNi
                </span>

                <p className="mt-6 text-sm font-semibold uppercase tracking-[0.22em] text-[#5e3b2c]">
                  Premium product image
                </p>

                <p className="mx-auto mt-3 max-w-xs text-sm leading-6 text-[#746d65]">
                  We will replace this placeholder with the RiNi product
                  collection photograph.
                </p>
              </div>
            </div>
          </div>

          <div className="absolute -bottom-6 -left-5 max-w-[230px] rounded-3xl bg-white p-5 shadow-xl">
            <p className="font-serif text-xl text-[#5e3b2c]">
              Crafted in small batches
            </p>
            <p className="mt-2 text-sm leading-6 text-[#746d65]">
              Follow the journey from ingredients to final packaging.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
